// extracted by mini-css-extract-plugin
export default {"invert":"ExternalBrandLogo-module__invert--ra8u6"};